import { makeStyles, Text, tokens } from '@fluentui/react-components';
import { BeakerRegular } from '@fluentui/react-icons';

type Props = {
  className?: string;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: tokens.colorBrandBackground2,
    borderLeft: `3px solid ${tokens.colorBrandStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
  },
  icon: {
    color: tokens.colorBrandForeground1,
    fontSize: '16px',
    lineHeight: '20px',
    flexShrink: 0,
  },
  text: {
    color: tokens.colorNeutralForeground2,
    lineHeight: '20px',
  },
});

export const AssistantBetaDisclaimer = ({ className }: Props) => {
  const styles = useStyles();
  return (
    <div className={className ? `${styles.container} ${className}` : styles.container}>
      <BeakerRegular className={styles.icon} />
      <Text size={200} className={styles.text}>
        L'Assistant est en version bêta. Son comportement peut évoluer et les
        réponses ne sont pas toujours fiables — n'hésitez pas à recouper les
        informations importantes.
      </Text>
    </div>
  );
};
